import { useDispatch, useSelector } from 'react-redux';
import { BOI_FORM_STEPS } from '../../../constants';
import RenderBoiFields from '../RenderBoiFields';
import styles from './Submit.styles';
import { componentKey as fileBoiComponentKey, setHelpTextObj, setShowHelpPopup, updateBoiFormFields } from '../../FileBoiSlice';
import { onDependentFieldChangeGetValues } from '../../FileBoiSaga';

export default function Submit(){

    const {boiFormFields, onDependentFields, formsPreLoadedData} = useSelector(state => state[fileBoiComponentKey])
    const dispatch = useDispatch();

    return <>
        <div style={styles.submitMainContainer}>
            <RenderBoiFields stepFields={boiFormFields[BOI_FORM_STEPS.SUBMIT] ?? []} updateFormFieldsCb={(updatedFieldsList) => dispatch(updateBoiFormFields({[BOI_FORM_STEPS.SUBMIT]: updatedFieldsList}))} onDependentFieldChangeGetValuesCb={(onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData))} currentStep={BOI_FORM_STEPS.SUBMIT} onDependentFields={onDependentFields} formsPreLoadedData={formsPreLoadedData} setShowHelpPopupCb={() => dispatch(setShowHelpPopup(true))} setHelpTextObjCb={(helpText) => dispatch(setHelpTextObj(helpText))} />
        </div>
    </>
}